import { render, staticRenderFns } from "./MapItemLoader.vue?vue&type=template&id=d18f8d5a"
import script from "./MapItemLoader.vue?vue&type=script&lang=js"
export * from "./MapItemLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports